import { useDispatch as useReactReduxDispatch } from "react-redux";
import { AnyAction, Dispatch } from "redux";

// TODO: We are typing useDispatch this way to work around issues with UnknownAction, the type that was introduced in Redux 5.
// If we decide to modernize to Redux 5, we will need to refactor much of the Rules Engine redux usage.
export const useDispatch =
  useReactReduxDispatch.withTypes<Dispatch<AnyAction>>();
